import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import {InsightsService} from "../../services/insights.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})

export class NavbarComponent implements OnInit {
  selectedTab: string = 'overview';
  isScreenHeightSmall: boolean = window.innerHeight < 900 || window.innerWidth < 1300;
  private selectedTabSubscription: Subscription;

  constructor(public insightsService: InsightsService,) {
    this.checkScreenHeight();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenHeight();
  }

  private checkScreenHeight() {
    this.isScreenHeightSmall =
      window.innerHeight < 900 || window.innerWidth < 1300;
    if (this.isScreenHeightSmall) {
      this.selectedTab = 'overview';
      this.tabSelected.emit(this.selectedTab);
    }
  }

  ngOnInit(): void {
    this.listenToSelectedTabChanges()
  }

  @Output() tabSelected = new EventEmitter<string>();

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.tabSelected.emit(this.selectedTab);
  }

  listenToSelectedTabChanges() {
    let availableTabs = {
      'overview_insights':'overview',
      'alarm_insights':'alarm',
      'operator_insights':'operator',
      'detailed_insights':'detailed',
    }
    this.selectedTabSubscription = this.insightsService.selectedInsight.subscribe(tab => {
      if (availableTabs[tab]) {
        this.selectTab(availableTabs[tab]);
      }
    });
  }
}
